var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { useAccordion } from '../';
import { BodyLarge } from '../../../typography';
import { fontWeight, color } from '../../../constants';
import { ArrowChevronUp, ArrowChevronDown } from '../../../icons';
var Label = styled(BodyLarge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  font-weight: ", ";\n  cursor: pointer;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  font-weight: ", ";\n  cursor: pointer;\n"])), fontWeight.bold);
export var Header = function (_a) {
    var label = _a.label;
    var _b = useAccordion(), toggleOpen = _b.toggleOpen, status = _b.status;
    return (React.createElement(Label, { onClick: toggleOpen },
        React.createElement("span", null, label),
        status === 'open' || status === 'opening' ? (React.createElement(ArrowChevronUp, { small: true, fillColor: color.pureBlack })) : (React.createElement(ArrowChevronDown, { small: true, fillColor: color.pureBlack }))));
};
var templateObject_1;
//# sourceMappingURL=Header.js.map